import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import * as performance from './performance.actions';
import { concat, EMPTY, Observable, of } from 'rxjs';
import { from } from 'rxjs/internal/observable/from';
import {
  Performance,
  PerformanceRequestCSVPayload
} from './performance.models';
import { HttpService } from '../../global/http.service';

import { downloadFile } from '../../global/fileDownload';
import { DatesIntervalRequest, DatesInterval } from '../../global/interfaces';
import { Actions as ActionsCDK } from "atlas-cdk";
import { ToastService } from '../../shared/toaster_/toaster_.service';

@Injectable()
export class PerformanceEffects {
  public loadPerformanceDates$ = createEffect(() => this.actions$.pipe(
    ofType<performance.LoadPerformanceDatesAction>(performance.ActionTypes.LOAD_PERFORMANCE_DATES),
    map(action => action.payload),
    switchMap((payload: DatesIntervalRequest) =>
      this.loadPerformanceDates(payload).pipe(
        map((response: DatesInterval) =>
          new performance.LoadPerformanceDatesSuccessAction(response)
        ),
        catchError(error =>
          // from([
          //   new performance.LoadPerformanceDatesFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new performance.LoadPerformanceDatesFailedAction(error));
          // }
          concat(
            of(new performance.LoadPerformanceDatesFailedAction(error)),
            of(null).pipe(
              tap(() => {
                this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  public loadPerformanceData$ = createEffect(() => this.actions$.pipe(
    ofType<performance.LoadPerformanceDataAction>(performance.ActionTypes.LOAD_PERFORMANCE_DATA),
    map(action => action.payload),
    switchMap(payload =>
      this.loadPerformanceData(payload).pipe(
        map((response: Performance) =>
          new performance.LoadPerformanceDataSuccessAction(response)
        ),
        catchError(error =>
          // from([
          //   new performance.LoadPerformanceDataFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new performance.LoadPerformanceDataFailedAction(error));
          // }
          concat(
            of(new performance.LoadPerformanceDataFailedAction(error)),
            of(null).pipe(
              tap(() => {
                this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  public fileDownload$ = createEffect(() => this.actions$.pipe(
    ofType<performance.PerformanceFileDownloadAction>(performance.ActionTypes.PERFORMANCE_FILE_DOWNLOAD),
    map(action => action.payload),
    switchMap(payload =>
      this.downloadPerformanceFile(payload).pipe(
        map((response: any) => {
          // deepcode ignore DOMXSS:internally created secure response
          downloadFile(response.body, 'text/csv', 'PerformanceExport.csv');
        }),
        catchError(() => {
          // from([
          //   new AddErrorToastAction('Download failed. Please try again later.')
          // ])

          this._toasterService.launchAlertError('Download failed. Please try again later.', ActionsCDK.error);
          return EMPTY;
        }
        )
      )
    )
  ), { dispatch: false });

  public constructor(
    private readonly actions$: Actions,
    private readonly http: HttpService,
    private readonly _toasterService: ToastService
  ) {
  }

  private loadPerformanceDates(payload: DatesIntervalRequest): Observable<DatesInterval> {
    return this.http.get(`/metrics/${payload.account}/date-ranges/performance`);
  }

  private loadPerformanceData(payload: any): Observable<Performance> {
    return this.http.post(`/performance/accounts/${payload.account}`, { year: payload.year, month: payload.month, option: payload.option });
  }

  private downloadPerformanceFile(payload: PerformanceRequestCSVPayload): Observable<Blob> {
    const account = payload.account;
    delete payload.account;
    const url = `/performance/accounts/${account}/export`;
    return this.http.post(url, payload, { observe: 'response', responseType: 'blob' },);
  }
}
